import React, {Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import history from '../util/history'
import { selectIsRequestPending } from '../util'
import Lozenge from '@atlaskit/lozenge'
import { Spinner, H3, H4} from '../components/index'
import Button from '@atlaskit/button'
import RefreshIcon from '@atlaskit/icon/glyph/refresh';

import { setIssue, getAllUserIssues } from './actions'
import { selectIssues, selectIssuesTotal} from './reducer'


const dateOptions = { year: 'numeric', month: 'long', day: 'numeric', 'hour': '2-digit', 'minute': '2-digit', 'hour12': false }

export class IssueList extends Component {
  componentWillMount() {
    let { getAllUserIssues } = this.props
    getAllUserIssues(false, 0)
  }

  handleRefresh = () => {
    let { getAllUserIssues } = this.props
    getAllUserIssues(true, 0)
  }

  handleLoadMore = () => {
    let { getAllUserIssues, userIssues } = this.props
    getAllUserIssues(false, userIssues.length + 1)
  }

  render () {
      let { setIssue, isSelectIssuesPending, userIssues, totalIssues } = this.props
      let rows = null
      if (userIssues.length > 0 && !isSelectIssuesPending ) {
        rows = userIssues.map(issue => {
          let created = new Date(issue.created)
          return (
            <tr className='u-cursor-pointer' key={issue.key} onClick={() => {
                setIssue(issue); history.push(`/requests/${issue.key}`)}}>
                  <td>{issue.key}</td>                    
                  <td><Lozenge appearance={issue.status.appearance} >{issue.status.name}</Lozenge></td>
                  <td>{issue.customfield_15740}</td>
                  <td>{issue.summary}</td>
                  <td>{created.toLocaleDateString('en-US', dateOptions)}</td>
              </tr>
          )
        })
      }
      

      return (
        <div>
          {
            isSelectIssuesPending ?
              <div>
                <H3 className='pb5-sm pr5-sm' >My Requests</H3>
                <Spinner medium />
              </div>
            : userIssues.length ?  
            <div>
              <H3 className='pb5-sm pr5-sm' >My Requests
                <button className='btn icon-solo' title='refresh' onClick={this.handleRefresh}><RefreshIcon size='medium' /></button>
              </H3>
              <div>showing {userIssues.length} of {totalIssues}
                <table className='page-table'>
                  <thead className='u-uppercase u-bold'>
                    <tr>
                      <th>Issue Key</th>
                      <th>Status</th>
                      <th>Request Type</th>
                      <th>Summary</th>
                      <th>Created</th>                    
                    </tr>
                  </thead>
                  <tbody>
                    {rows}
                  </tbody>                
                </table>
                {
                  userIssues.length < totalIssues ? 
                  <Button type='button' onClick={this.handleLoadMore} appearance='primary'>
                  Load More <i className={`fa ${isSelectIssuesPending ? 'fa-circle-o-notch fa-spin' : null}`} />
                  </Button> : null
                }
              </div>
            </div>
          : 
            <div>    
              <H4 className='border-top-black pt4-sm'>You have not created any Requests</H4>    
            </div>                      
          }
        </div>
        )
  }
}

export default withRouter(connect((state) => {
  return {
    isSelectIssuesPending: selectIsRequestPending(state, getAllUserIssues),
    userIssues: selectIssues(state),
    totalIssues: selectIssuesTotal(state),
  }
}, { setIssue, getAllUserIssues }) (IssueList))
// improvements: get status color from API and make Status value a colored Pill matching the status color
// allow for the number of results to be limited. Home page should limit to 5 results
// If number of results are limited and there are more results then the limit
// there should be a configurable link to take the user to all issues


// WEBPACK FOOTER //
// ./client/src/serviceDesk/IssueList.js